/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';
import { IGuestCheckoutOnAccountThankYouViewProps } from './guest-checkout-on-account-thank-you';

export default (props: IGuestCheckoutOnAccountThankYouViewProps) => {
    const { moduleProps, heading, orderId, thankYou, successMessage, backToShoppingLink } = props;
    return (
        <Module {...moduleProps}>
                {heading}
                <div className='ms-guest-checkout-on-account-order-info'>
                    {orderId}
                    {thankYou}
                    {successMessage}
                </div>
            {backToShoppingLink}
        </Module>
    );
};
